import { MarketTrendDataPointsResponse, MarketTrendsLabels, TREND_TYPES } from '../../types/marketTrends';

export default (data: MarketTrendDataPointsResponse[]): MarketTrendsLabels =>
  TREND_TYPES.reduce((a, c) => {
    a[c] = data.find((d) => d.level === c)?.label || '';
    return a;
  }, {} as MarketTrendsLabels);
